import React, {useRef} from "react";
import {injectIntl} from "react-intl";
import {useClickOutside} from "hooks";
import classNames from "classnames/bind";
import styles from "./index.module.scss";

const ContextMenu = ({intl, xPos, yPos, setIsClick, onClickProfile, onClickBlock}) => {
  const cn = classNames.bind(styles);
  const contextMenuRef = useRef(null);
  useClickOutside(contextMenuRef, () => setIsClick(false));
  return (
    <ul ref={contextMenuRef} className={cn("voice_context_menu")} style={{top: yPos, left: xPos}}>
      <li onClick={onClickProfile} onTouchEnd={onClickProfile}>
        {intl.formatMessage({id: "ID_CHAT_MENU_PROFILE"})}
      </li>
      <li onClick={onClickBlock} onTouchEnd={onClickBlock}>
        {intl.formatMessage({id: "ID_CHAT_MENU_BLOCK"})}
      </li>
    </ul>
  );
};

export default injectIntl(ContextMenu);
